/**
 * Desktop Navigation Submenu - Hover-triggered product panels
 *
 * Shows product dropdown when hovering over navigation links
 * Desktop only (990px+)
 */

class DesktopNavSubmenu {
  constructor() {
    this.container = document.querySelector('.desktop-nav-submenu');
    if (!this.container) return;

    this.items = this.container.querySelectorAll('.desktop-nav-submenu__item');
    this.init();
  }

  init() {
    if (window.matchMedia('(max-width: 989px)').matches) {
      return;
    }

    this.items.forEach((item) => {
      const dropdown = item.querySelector('.desktop-nav-submenu__dropdown');
      if (!dropdown) return;

      let hideTimeout = null;
      let isHovering = false;

      item.addEventListener('mouseenter', () => {
        isHovering = true;
        clearTimeout(hideTimeout);
        dropdown.style.display = 'block';

        requestAnimationFrame(() => {
          dropdown.style.opacity = '1';
          dropdown.style.transform = 'translateY(0)';
        });
      });

      item.addEventListener('mouseleave', () => {
        isHovering = false;
        hideTimeout = setTimeout(() => {
          if (!isHovering) {
            dropdown.style.opacity = '0';
            dropdown.style.transform = 'translateY(-0.8rem)';
            setTimeout(() => {
              if (!isHovering) {
                dropdown.style.display = 'none';
              }
            }, 200);
          }
        }, 150);
      });

      dropdown.addEventListener('mouseenter', () => {
        isHovering = true;
        clearTimeout(hideTimeout);
      });

      dropdown.addEventListener('mouseleave', () => {
        isHovering = false;
        hideTimeout = setTimeout(() => {
          if (!isHovering) {
            dropdown.style.opacity = '0';
            dropdown.style.transform = 'translateY(-0.8rem)';
            setTimeout(() => {
              if (!isHovering) {
                dropdown.style.display = 'none';
              }
            }, 200);
          }
        }, 150);
      });
    });

    document.addEventListener('click', (e) => {
      if (!this.container.contains(e.target)) {
        this.closeAllDropdowns();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeAllDropdowns();
      }
    });

    window.addEventListener('resize', () => {
      if (window.matchMedia('(max-width: 989px)').matches) {
        this.closeAllDropdowns();
      }
    });
  }

  closeAllDropdowns() {
    const dropdowns = this.container.querySelectorAll('.desktop-nav-submenu__dropdown');
    dropdowns.forEach((dropdown) => {
      dropdown.style.opacity = '0';
      dropdown.style.transform = 'translateY(-0.8rem)';
      setTimeout(() => {
        dropdown.style.display = 'none';
      }, 200);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new DesktopNavSubmenu();
});

if (typeof window !== 'undefined') {
  window.DesktopNavSubmenu = DesktopNavSubmenu;
}